<template>
  <b-card
    :sub-title="subtitleImg"
    :header="titleImg"
    border-variant="secondary"
    header-border-variant="secondary"
    align="center"
    no-body
  >
    <b-card-img
      :src="imagesrc"
      top
      width="100%"
      style="cursor:pointer"
      @click="onClick(pathImg)"
    />
    <b-card-body>
      <b-img
        v-for="(item, index) in sourcePictutes"
        :key="index"
        :src="item"
        width="40px"
        height="40px"
        class="postcard"
        @click="imagesrc=item"
      />
      <b-row
        align-h="center"
        style="margin-top:5px"
      >
        <b-button
          v-b-toggle.collapse-1
          size="sm"
          variant="outline-secondary"
          @click="visible=!visible"
        >
          {{ visible ? 'Skry detaily' : 'Zobraz detaily' }}
        </b-button>
      </b-row>
      <b-collapse
        v-model="visible"
        class="mt-2"
      >
        <b-card-text>
          {{ detailsImg }}
        </b-card-text>
        <b-card-text>
          <b>Veľkosť: </b>{{ sizeImg }}
        </b-card-text>
        <b-card-text>
          <b>Materiál: </b>{{ materialImg }}
        </b-card-text>
        <b-card-text>
          <b>Spôsob výroby: </b>{{ kindImg }}
        </b-card-text>
      </b-collapse>
    </b-card-body>
  </b-card>
</template>

<script>
import { ref } from "@vue/composition-api"

export default {
  name: 'Picture',
  props: {
    titleImg: {
      type: String,
      default: ""
    },
    subtitleImg: {
      type: String,
      default: ""
    },
    detailsImg: {
      type: String,
      default: ""
    },
    sizeImg: {
      type: String,
      default: ""
    },
    materialImg: {
      type: String,
      default: ""
    },
    kindImg: {
      type: String,
      default: ""
    },
    sourcePictutes: {
      type: Array,
      default: () => []
    },
    pathImg: {
      type: String,
      default: ""
    }
  },
  setup(props, context) {
    const imagesrc = ref(props.sourcePictutes[0])
    const visible = ref(false)

    function onClick(path) {
      context.root.$router.push(path)
    }

    return {
      imagesrc,
      visible,
      onClick
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Picture.vue